const drawerNotice = document.getElementById('drawer-notice');

let currentController = null;

function wait(ms, signal) {
	return new Promise((resolve, reject) => {
		const timeout = setTimeout(resolve, ms);

		signal?.addEventListener('abort', () => {
			clearTimeout(timeout);
			reject(new DOMException('Aborted', 'AbortError'));
		});
	});
}

function waitTransition(element, signal) {
	return new Promise((resolve, reject) => {
		const handler = () => resolve();

		element.addEventListener('transitionend', handler, { once: true });

		signal?.addEventListener('abort', () => {
			element.removeEventListener('transitionend', handler);
			reject(new DOMException('Aborted', 'AbortError'));
		});
	});
}

async function toggleNotice(type, message) {
	if (currentController) {
		currentController.abort();
	}

	const controller = new AbortController();
	currentController = controller;
	const { signal } = controller;

	try {
		await openNotice(type, message, signal);
		await wait(2000, signal);
		await closeNotice(signal);
	} catch (err) {
		if (err.name !== 'AbortError') {
			console.error(err);
		}
	} finally {
		if (currentController === controller) {
			currentController = null;
		}
	}
}

async function openNotice(type, message, signal) {
	drawerNotice.dataset.noticeType = type;
	drawerNotice.querySelector('p').textContent = message;
	drawerNotice.dataset.state = 'visible';

	await waitTransition(drawerNotice, signal);
}

async function closeNotice(signal) {
	drawerNotice.dataset.state = 'closing';
	await waitTransition(drawerNotice, signal);
	drawerNotice.dataset.state = 'hidden';
}
